import React from "react";
import { Can as CaslCan } from "@casl/react";
import { useAbility } from "../hooks/hooks";
import { Actions, Subjects } from "../abilities";

interface CanProps {
  do: Actions | Actions[];
  on: Subjects | Subjects[];
  children?: React.ReactNode;
  passThrough?: boolean;
  not?: boolean;
}

export function Can({ do: action, on: subject, children, passThrough = false, not = false }: CanProps) {
  const { ability } = useAbility();

  return (
    <CaslCan
      I={action}
      a={subject}
      ability={ability}
      passThrough={passThrough}
      not={not}
    >
      {children}
    </CaslCan>
  );
}
